// extracted by mini-css-extract-plugin
module.exports = {"scrollArrow":"ScrollArrowLink_scrollArrow__2PjFw","scrollArrowPortal":"ScrollArrowLink_scrollArrowPortal__3SM6k","scrollArrowRotate":"ScrollArrowLink_scrollArrowRotate__3LiTv"};